import type { SubscriptionPlan } from '@/hooks/useAuthState';

export type PlanSlug = SubscriptionPlan;

export type PlanMeta = {
  slug: PlanSlug;
  label: string;
  shortLabel: string;
  description: string;
  badgeClassName: string;
  /** Destaque visual do plano principal */
  featured?: boolean;
  highlights: string[];
};

const PLAN_META: Record<PlanSlug, PlanMeta> = {
  live: {
    slug: 'live',
    label: 'Plano Live',
    shortLabel: 'Live',
    description:
      'Acesso completo à plataforma: todos os resorts, imóveis, reservas, documentos e recursos para proprietários.',
    badgeClassName:
      'border-transparent bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-sm',
    featured: true,
    highlights: [
      'Imóveis em todos os empreendimentos',
      'Reservas, solicitações e mensagens',
      'Documentos e contratos',
      'Contato direto com proprietários',
      'Cotas à venda e suporte prioritário',
    ],
  },
  porto2life: {
    slug: 'porto2life',
    label: 'Plano Porto 2 Life',
    shortLabel: 'Porto 2 Life',
    description:
      'Gerenciamento de imóveis e reservas no empreendimento Porto 2 Life, com recursos dedicados a esse resort.',
    badgeClassName:
      'border-transparent bg-gradient-to-r from-sky-600 to-blue-700 text-white shadow-sm',
    highlights: [
      'Cadastro de imóveis no Porto 2 Life',
      'Reservas e solicitações no empreendimento',
      'Mensagens com hóspedes',
    ],
  },
  freemium: {
    slug: 'freemium',
    label: 'Plano Essencial',
    shortLabel: 'Essencial',
    description:
      'Conta gratuita com funcionalidades básicas. Para publicar e gerenciar imóveis em toda a rede, assine o plano Live.',
    badgeClassName:
      'border-slate-200 bg-slate-100 text-slate-800 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100',
    highlights: [
      'Busca e reservas como hóspede',
      'Favoritos e mensagens',
      'Sem gestão de imóveis na rede completa',
    ],
  },
};

export function normalizePlanSlug(
  plan: string | null | undefined,
  planId?: number | null,
): PlanSlug {
  if (plan === 'live' || plan === 'porto2life' || plan === 'freemium') {
    return plan;
  }
  if (planId === 3) return 'live';
  if (planId === 2) return 'porto2life';
  return 'freemium';
}

export function getPlanMeta(
  plan: string | null | undefined,
  planId?: number | null,
): PlanMeta {
  return PLAN_META[normalizePlanSlug(plan, planId)];
}

export function hasFullPlatformAccess(plan: PlanSlug): boolean {
  return plan === 'live';
}

export function canManagePropertiesOnPlatform(plan: PlanSlug): boolean {
  return plan === 'live' || plan === 'porto2life';
}
